import React from "react";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";
import { X } from "lucide-react";
import IconContainer from "@/components/ui/icon-container";

export interface BulkAction {
  key: string;
  label: string;
  onClick: () => void;
  show?: boolean;
  disabled?: boolean;
  tooltipText?: string;
}

interface BulkActionPopoverProps {
  selectedCount: number;
  /** Already-translated text shown after the count, e.g. "Selected" in "3 Selected". */
  selectedText: string;
  actions: BulkAction[];
  onClose: () => void;
}

const BulkActionPopover: React.FC<BulkActionPopoverProps> = ({
  selectedCount,
  selectedText,
  actions,
  onClose
}) => {
  const visibleActions = actions.filter((action) => action.show !== false);

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div className="flex flex-row items-center bg-surface-elevation3 border border-border-border1 rounded-2xl shadow-lg p-4 pl-6">
        <Text variant="body" className="font-medium mr-12">
          {selectedCount} {selectedText}
        </Text>
        <div className="flex items-center gap-3">
          {visibleActions.map((action) => (
            <Button
              key={action.key}
              variant="secondaryNoBg"
              onClick={action.disabled ? undefined : action.onClick}
              disabled={action.disabled}
              className="flex-1"
              tooltipText={action.tooltipText}
            >
              {action.label}
            </Button>
          ))}
        </div>
        <div className="w-[1px] h-8 bg-border-border2 mx-6" />

        <Button
          variant="tertiary"
          onClick={onClose}
          className="text-secondary hover:text-primary"
        >
          <IconContainer size="md">
            <X />
          </IconContainer>
        </Button>
      </div>
    </div>
  );
};

export default BulkActionPopover;
